//messages.js
export default {
	provider_id: "Provider ID",
	provider_id: "Provider ID",
	third_party: "Third Party",
	service_name: "Service Name",
	logo: "Logo",
	client_id: "Client ID",
	org_id: "Organisation ID",
	client_id: "Client ID",
	client_secret: "Client Secret",
	scopes: "Scopes",
	api_base: "Api Base",
	auth_uri: "Auth URI",
	redirect_uri: "Redirect URI",
	redirect_auth_uri: "Redirect Post Auth URI",
	edit_oauth_provider: "Edit Oauth Provider",
	add_oauth_provider: "Add Oauth Provider",
	delete_oauth_provider: "Delete Oauth Provider",
	oauth_providers: "Oauth Providers",
	delete_oauth_provider_confirm: "This action is not reversible!",
	oauth_provider: "Oauth Provider",
	authorize: "Authorize",
	re_authorize: "Re-Authorize",
};
